import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63c179f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c179f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c179f4')) {
      api.createRecord('63c179f4', component.options)
    } else {
      api.reload('63c179f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=63c179f4&scoped=true", function () {
      api.rerender('63c179f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/position/index.vue"
export default component.exports